import { useCurrentStateAndParams } from "@uirouter/react";

import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { WEBSITE_ANALYSIS_WIDGET_NAMES } from "app/pages/sales-intelligence/pages/company-analysis/constants";
import WWOTrafficTopCountries from "app/pages/website-performance/components/TopCountries/WWOTrafficTopCountries";
import { DEFAULT_HOOKS_MODAL_ID } from "app/pages/workspace/config/stateToWsConfigMap";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOTrafficTopCountriesContainerSI = ({ hideFooter = false }: { hideFooter?: boolean }) => {
    const { params } = useCurrentStateAndParams();

    const getCtaLink = () => {
        return {
            href: proNavigator.href("accountreview_website_audience_geography", params),
            target: "_self",
            onClick: () => {
                companyAnalysisTrackingService.website.trackWidgetCtaClick(
                    WEBSITE_ANALYSIS_WIDGET_NAMES.geography,
                    params.key,
                );
            },
        };
    };
    return (
        <WWOTrafficTopCountries
            getCtaLink={getCtaLink}
            params={params}
            unlockHook={{
                component: "WebGeography",
                hookModal: DEFAULT_HOOKS_MODAL_ID,
            }}
            hideFooter={hideFooter}
        />
    );
};
